import React from 'react'
import { ErrorMessage } from 'formik'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'

import errorIcon from 'images/error-icon.svg'

/*

These are very close approximations of the helper methods in LeadGen.jsx
need to find the right way to pass props (and not break leadgen)

differences are captured in comments
*/

// difference: passing fullWidth to FormControl & TextFied
// difference: markup of errors
export const renderTextInput = props => {
  const errorExists = props.error || props.errors

  return (
    <FormControl
      className={`field field-${props.field.name}${props.index || ''}`}
      fullWidth={props.fullWidth}
      key={props.field.name}
    >
      <TextField
        error={props.error && props.touched && true}
        // helperText={props.error && props.touched && props.error} // this appears below the field
        label={props.label}
        type={props.type}
        value={props.field.value}
        variant="filled"
        name={props.field.name}
        fullWidth={props.fullWidth}
        onChange={e => {
          // props.form.setFieldTouched(props.field.name, true, false)
          // props.form.handleChange(e.target)
          props.form.setFieldValue(props.field.name, e.target.value)
        }}
      />
      {errorExists && props.touched && (
        <div className="error">
          <img className="error-icon" src={errorIcon} alt="" />
          <ErrorMessage name={props.field.name} />
        </div>
      )}
    </FormControl>
  )
}

// this is very close to renderTextInput. doesn't exist in leadgen.
// fullWidth
// multiline={true}
// rows =
export const renderTextArea = props => {
  const errorExists = props.error || props.errors

  return (
    <FormControl
      className={`field field-${props.field.name}${props.index || ''}`}
      fullWidth
      key={props.field.name}
    >
      <TextField
        error={props.error && props.touched && true}
        // helperText={props.error && props.touched && props.error} // this appears below the field
        label={props.label}
        type={props.type}
        value={props.field.value}
        variant="filled"
        name={props.field.name}
        multiline={true}
        fullWidth
        rows={props.rows ? props.rows : 8}
        onChange={e => {
          props.form.setFieldValue(props.field.name, e.target.value)

          // const formValues = props.form.values;
          // const isFormIncomplete = Object.values(formValues).some(
          //     value => value === "" || value === false || value === undefined
          // )
          // !isFormIncomplete && props.setStepState('COMPLETE')
        }}
      />
      {errorExists && props.touched && (
        <div className="error">
          <img className="error-icon" src={errorIcon} alt="" />
          <ErrorMessage name={props.field.name} />
        </div>
      )}
    </FormControl>
  )
}
